module.exports = "../../static/img/default.bd83f4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/avatars/default.jpg
// module id = 2063
// module chunks = 0